







































































import Vue from "vue"
import { Component } from "vue-property-decorator"
import NiPage from "@nielsen-media/nlsn-vue-ui/lib/components/NiPage.vue"
import { CatOrganization } from "@/store/modules/organizations/organizations"
import { ROUTES } from "@/constants"

@Component({
  components: { NiPage },
  filters: {
    formatDate(value: string) {
      if (!value) return ""
      return new Date(value).toLocaleString()
    },
  },
})
export default class ManageOrganizations extends Vue {
  title = "Manage Organizations"
  search = ""
  createDialog = false
  newOrg = { name: "", status: "active" }
  statusOptions = ["active", "inactive"]

  headers = [
    { text: "Cat Organization ID", value: "id", sortable: true },
    { text: "Name", value: "name", sortable: true },
    { text: "Created At", value: "createdAt", sortable: true },
    { text: "Updated At", value: "updatedAt", sortable: true },
  ]

  get organizations(): CatOrganization[] {
    return this.$store.getters["organizations/all"]
  }

  get loading(): boolean {
    return this.$store.getters["organizations/loading"]
  }

  get filteredOrganizations(): CatOrganization[] {
    if (!this.search) return this.organizations
    const q = this.search.toLowerCase()
    return this.organizations.filter(o =>
      o.id.toLowerCase().includes(q) ||
      o.name.toLowerCase().includes(q) ||
      new Date(o.createdAt).toLocaleString().toLowerCase().includes(q) ||
      new Date(o.updatedAt).toLocaleString().toLowerCase().includes(q)
    )
  }

  created(): void {
    this.$store.dispatch("organizations/loadOrganizations")
  }

  goToDetail(item: CatOrganization): void {
    this.$router.push({ name: ROUTES.ORGANIZATION_DETAIL.name, params: { id: item.id } })
  }

  openCreateDialog(): void {
    this.newOrg = { name: "", status: "active" }
    this.createDialog = true
  }

  async createOrganization(): Promise<void> {
    await this.$store.dispatch("organizations/createOrganization", {
      name: this.newOrg.name,
      status: this.newOrg.status,
    })
    this.createDialog = false
  }
}
